// extracted by mini-css-extract-plugin
export var brand = "_5s-8";
export var compact = "_5s-5";
export var extraSmall = "_5s-6";
export var icon = "_5s-0";
export var large = "_5s-3";
export var light = "_5s-1";
export var medium = "_5s-4";
export var outline = "_5s-a";
export var primaryDark = "_5s-9";
export var primaryLight = "_5s-7";
export var primaryModern = "_5s-b";
export var success = "_5s-2";